import { render, staticRenderFns } from "./BatchCollectionUpdateModal.vue?vue&type=template&id=4e721a76&scoped=true"
import script from "./BatchCollectionUpdateModal.vue?vue&type=script&lang=js"
export * from "./BatchCollectionUpdateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e721a76",
  null
  
)

export default component.exports